var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogTitle, DialogContent, Card, CardContent, Grid, DialogActions, Button, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { inject, observer } from "mobx-react";
import React from "react";
var SigningDialog = /** @class */ (function (_super) {
    __extends(SigningDialog, _super);
    function SigningDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: '',
            selectedSignatureName: '',
            isPlaceholderEnabled: false
        };
        return _this;
    }
    Object.defineProperty(SigningDialog, "getDerivedStateFromProps", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (newProps, state) {
            var _a, _b, _c, _d, _e;
            var signingText = (_b = (_a = newProps.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType) === null || _b === void 0 ? void 0 : _b.signingText;
            var signatures = (_c = newProps.signingStore) === null || _c === void 0 ? void 0 : _c.parseSignatures(signingText);
            var selectedSignature;
            if (signatures && signatures.length > 0) {
                if (state.selectedSignatureName && signatures.find(function (s) { return s.name === state.selectedSignatureName; }))
                    return null;
                selectedSignature = signatures[0];
            }
            return __assign(__assign({}, state), { value: '', selectedSignatureName: (_d = selectedSignature === null || selectedSignature === void 0 ? void 0 : selectedSignature.name) !== null && _d !== void 0 ? _d : '', isPlaceholderEnabled: (_e = selectedSignature === null || selectedSignature === void 0 ? void 0 : selectedSignature.isPlaceholderEnabled) !== null && _e !== void 0 ? _e : false });
        }
    });
    Object.defineProperty(SigningDialog.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g;
            if (!((_a = this.props.signingStore) === null || _a === void 0 ? void 0 : _a.isSigningDialogVisible)) {
                return (_jsx("div", {}, void 0));
            }
            var caseType = (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.currentCaseType;
            if (!caseType) {
                return (_jsx("div", {}, void 0));
            }
            var labelId = 'idSignatureSelector';
            var label = 'Select signature';
            var signatures = (_c = this.props.signingStore) === null || _c === void 0 ? void 0 : _c.parseSignatures(caseType === null || caseType === void 0 ? void 0 : caseType.signingText);
            var selectedSignature = signatures === null || signatures === void 0 ? void 0 : signatures.find(function (s) { return s.name === _this.state.selectedSignatureName; });
            var options = signatures === null || signatures === void 0 ? void 0 : signatures.map(function (s) { return _jsx(MenuItem, __assign({ value: s.name }, { children: s.name }), s.name); });
            var signaturesDropdown = (_jsx(Grid, __assign({ item: true }, { children: _jsxs(FormControl, __assign({ fullWidth: true, variant: "outlined" }, { children: [_jsx(InputLabel, __assign({ id: labelId }, { children: label }), void 0), _jsx(Select, __assign({ labelId: labelId, value: this.state.selectedSignatureName, label: label, disabled: !(caseType === null || caseType === void 0 ? void 0 : caseType.enableSigning) || !signatures || signatures.length === 0, onChange: function (e) { return _this.onSelectedSignatureChanged(e); } }, { children: options }), void 0)] }), void 0) }), void 0));
            var signatureText = (_d = selectedSignature === null || selectedSignature === void 0 ? void 0 : selectedSignature.content) !== null && _d !== void 0 ? _d : '';
            if ((selectedSignature === null || selectedSignature === void 0 ? void 0 : selectedSignature.isPlaceholderEnabled) && this.state.value) {
                signatureText = signatureText.split('{value}').join(this.state.value); // replace all occurrences
            }
            var valueInput = (selectedSignature === null || selectedSignature === void 0 ? void 0 : selectedSignature.isPlaceholderEnabled) ?
                (_jsx(Grid, __assign({ item: true }, { children: _jsx(TextField, { variant: "outlined", fullWidth: true, autoFocus: true, InputLabelProps: { shrink: true }, onChange: function (e) { return _this.onValueChanged(e); }, value: this.state.value, label: "Value", required: true }, void 0) }), void 0)) : null;
            return (_jsxs(Dialog, __assign({ open: true, onClose: function () { return _this.onCloseDialog(false); } }, { children: [_jsx(DialogTitle, { children: (_e = this.props.languageStore) === null || _e === void 0 ? void 0 : _e.getLabel('Request signature') }, void 0), _jsx(DialogContent, __assign({ sx: { minWidth: '600px', minHeight: '600px', display: 'flex' } }, { children: _jsx(Card, __assign({ sx: { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' } }, { children: _jsx(CardContent, __assign({ sx: { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto' } }, { children: _jsxs(Grid, __assign({ container: true, flex: "1", direction: "column", justifyContent: "stretch", rowSpacing: 3 }, { children: [signaturesDropdown, valueInput, _jsx(Grid, __assign({ item: true }, { children: _jsx("div", { dangerouslySetInnerHTML: { __html: signatureText } }, void 0) }), void 0)] }), void 0) }), void 0) }), void 0) }), void 0), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ variant: "contained", disabled: !this.isFormValid(caseType), onClick: function (e) { return _this.onCloseDialog(true); } }, { children: (_f = this.props.languageStore) === null || _f === void 0 ? void 0 : _f.getLabel('OK') }), void 0), _jsx(Button, __assign({ variant: "outlined", onClick: function (e) { return _this.onCloseDialog(false); } }, { children: (_g = this.props.languageStore) === null || _g === void 0 ? void 0 : _g.getLabel('Cancel') }), void 0)] }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(SigningDialog.prototype, "onValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            this.setState(__assign(__assign({}, this.state), { value: e.target.value }));
        }
    });
    Object.defineProperty(SigningDialog.prototype, "onSelectedSignatureChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var selectedSignature = this.getSignature(e.target.value);
            if (selectedSignature) {
                this.setState(__assign(__assign({}, this.state), { selectedSignatureName: selectedSignature.name, isPlaceholderEnabled: selectedSignature.isPlaceholderEnabled }));
            }
            else {
                this.setState(__assign(__assign({}, this.state), { selectedSignatureName: '', isPlaceholderEnabled: false }));
            }
        }
    });
    Object.defineProperty(SigningDialog.prototype, "getSignature", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (name) {
            var _a, _b, _c, _d;
            return (_d = (_a = this.props.signingStore) === null || _a === void 0 ? void 0 : _a.parseSignatures((_c = (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.currentCaseType) === null || _c === void 0 ? void 0 : _c.signingText)) === null || _d === void 0 ? void 0 : _d.find(function (s) { return s.name === name; });
        }
    });
    Object.defineProperty(SigningDialog.prototype, "onCloseDialog", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isOK) {
            var _a;
            var signatureText = '';
            if (isOK) {
                var signature = this.getSignature(this.state.selectedSignatureName);
                if (!signature)
                    return;
                if (signature.isPlaceholderEnabled) {
                    if (!this.state.value)
                        return;
                    signatureText = signature.content.split('{value}').join(this.state.value); // replace all occurrences
                }
                else {
                    signatureText = signature.content;
                }
            }
            (_a = this.props.signingStore) === null || _a === void 0 ? void 0 : _a.closeSigningDialog(isOK, signatureText);
        }
    });
    Object.defineProperty(SigningDialog.prototype, "isFormValid", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseType) {
            var signature = this.getSignature(this.state.selectedSignatureName);
            if (!signature)
                return false;
            if (!signature.content || !signature.content.trim())
                return false;
            if (!signature.isPlaceholderEnabled)
                return true;
            if (this.state.value)
                return true;
            return false;
        }
    });
    SigningDialog = __decorate([
        inject('languageStore'),
        inject('signingStore'),
        inject('caseTypesStore'),
        observer
    ], SigningDialog);
    return SigningDialog;
}(React.Component));
export default SigningDialog;
